import {
  buildContactIdLookupHooks,
  buildPropertyIdLookupHooks,
  mapCustomFieldsToDromoFields
} from 'bundles/crm/imports/helpers';
import { LEASE_FIELDS, SALE_FIELDS } from './fields';

import type { CustomField } from 'bundles/apex/custom_fields/types';

export const SALE = 'sale';
export const LEASE = 'lease';
export type CompType = typeof SALE | typeof LEASE | null;

const modelTypeMap = {
  [SALE]: 'Research::Sale',
  [LEASE]: 'Research::Lease',
};

const ownerHooks = [
  buildContactIdLookupHooks(
    'Owner Contact ID',
    { idKey: 'ownerContactId', queryKey: 'ownerName' },
  ),
  ...[2, 3, 4, 5, 6].map(i => buildContactIdLookupHooks(
    `Owner Contact ID ${i}`,
    { idKey: `ownerContactId${i}`, queryKey: `ownerName${i}` },
  )),
];

const tenantHooks = buildContactIdLookupHooks(
  'Tenant Contact ID',
  { idKey: 'tenantContactId', queryKey: 'tenantName' },
);

const buyerHooks = buildContactIdLookupHooks(
  'Buyer Contact ID',
  { idKey: 'buyerContactId', queryKey: 'buyerName' },
);

const sellerHooks = buildContactIdLookupHooks(
  'Seller Contact ID',
  { idKey: 'sellerContactId', queryKey: 'sellerName' },
);

const propertyHooks = buildPropertyIdLookupHooks(
  'Property ID',
  { idKey: 'propertyId', queryKey: 'property' },
  { force: true },
);

const DROMO_PROPS = {
  [SALE]: {
    bulkRowHooks: [propertyHooks.bulkRowHook, buyerHooks.bulkRowHook, sellerHooks.bulkRowHook],
    fields: SALE_FIELDS,
    groupId: 'crm_sale_comps',
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::SaleComps',
    },
    importerType: 'crm',
    stepHooks: [propertyHooks.stepHook, buyerHooks.stepHook, sellerHooks.stepHook],
    title: 'Sale Comps',
  },
  [LEASE]: {
    bulkRowHooks: [
      propertyHooks.bulkRowHook,
      ...ownerHooks.map(fieldHooks => fieldHooks.bulkRowHook),
      tenantHooks.bulkRowHook,
    ],
    fields: LEASE_FIELDS,
    groupId: 'crm_lease_comps',
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::LeaseComps',
    },
    importerType: 'crm',
    stepHooks: [
      propertyHooks.stepHook,
      ...ownerHooks.map(fieldHooks => fieldHooks.stepHook),
      tenantHooks.stepHook,
    ],
    title: 'Lease Comps',
  }
};

export function getDromoImporterConfig(compType: CompType, customFields: CustomField[]) {
  if (compType) {
    const modelType = modelTypeMap[compType];
    const customFieldsForCompType = customFields.filter(field => field.classNames.includes(modelType));
    return {
      ...DROMO_PROPS[compType],
      fields: [...DROMO_PROPS[compType].fields, ...mapCustomFieldsToDromoFields(customFieldsForCompType)],
    };
  }
}

export const compGroupIds = [
  DROMO_PROPS[SALE].groupId,
  DROMO_PROPS[LEASE].groupId,
];
